/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { ReactComponent as Logo } from "./../../assets/images/logo/Logo.svg";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { ButtonAction } from "../../components/NewButtons";
import { useNavigate } from "react-router";
import { routes } from "../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { PrimaryButton } from "../../components/Buttons";

const UIWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100%;
  margin-top: auto;
  margin-bottom: auto;
`;

export const ErrorUIFallback = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const navigate = useNavigate();

  return (
    <div css={UIWrapper}>
      <Logo />
      <StyledText className="headerOne mb-0" color={colors.textPrimary}>
        Something went wrong!
      </StyledText>
      <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
        An unknown error occurred. Please try again.
      </StyledText>
      <ButtonAction
        type="button"
        onClick={() => {
          if (window) {
            window.location.reload();
          }
        }}
      >
        Reload page
      </ButtonAction>
      <PrimaryButton
        type="button"
        backgroundColor={colors.transparent}
        color={colors.textPrimary}
        hoverColor={colors.whiteHover}
        onClick={() => {
          navigate(routes.home(organizationKeyName));
          if (window) {
            window.location.reload();
          }
        }}
      >
        Go to home
      </PrimaryButton>
    </div>
  );
};
